export const ATS_QUERY_KEYS = {
  connections: ['GET_ATS_CONNECTIONS'] as const,
  jobs: (connectionId: string) => ['GET_ATS_JOBS', connectionId] as const,
};
